<template>
  <v-form ref="form" v-model="valid">
    <v-stepper v-model="e6" vertical>
      <v-stepper-step :complete="e6 > 1" step="1">
        {{ $t('common.Type') }}
      </v-stepper-step>

      <v-stepper-content step="1">
        <v-flex xs6>
          <v-select
            :disabled="isLinking"
            :rules="mandatoryRule"
            v-model="formData.type"
            :items="types"
            :label="$t('common.Type')"
            required
          />

          <v-select
            :rules="mandatoryRule"
            v-model="formData.subType"
            :items="subTypesPublication"
            :label="$t('common.SubType')"
            v-if="formData.type === 1"
            required
          />

          <v-select
            :rules="mandatoryRule"
            v-model="formData.subType"
            :items="subTypesPresentation"
            :label="$t('common.SubType')"
            v-if="formData.type === 2"
            required
          />
        </v-flex>
        <v-btn
          depressed
          color="primary"
          :disabled="!formData.type || !formData.subType"
          @click="e6 = 2"
          >{{ $t('common.Continue') }}</v-btn
        >
      </v-stepper-content>

      <v-stepper-step :complete="e6 > 2" step="2">
        {{ $t('common.Title') }}
      </v-stepper-step>

      <v-stepper-content step="2">
        <v-flex xs6>
          <v-text-field
            :rules="mandatoryRule"
            v-model="formData.title"
            :label="$t('common.Title')"
            required
          />

          <div v-if="showDate">
            <v-menu
              v-model="datePicker"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="formData.date"
                  :label="$t('common.Date')"
                  prepend-icon="event"
                  readonly
                  :rules="mandatoryRule"
                  required
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="formData.date"
                @input="datePicker = false"
              ></v-date-picker>
            </v-menu>
          </div>
        </v-flex>
        <v-btn
          depressed
          color="primary"
          @click="e6 = 3"
          :disabled="!formData.title"
          >{{ $t('common.Continue') }}</v-btn
        >
        <v-btn flat @click="e6 = 1">{{ $t('common.Previous') }}</v-btn>
      </v-stepper-content>

      <v-stepper-step v-if="hasJournal" :complete="e6 > 3" step="3">
        {{ $t('common.Journal') }}
      </v-stepper-step>

      <v-stepper-content v-if="hasJournal" step="3">
        <v-layout>
          <v-flex xs12>
            <v-text-field
              :rules="mandatoryRule"
              v-model="formData.paperTitle"
              :label="$t('common.PaperTitle')"
              required
            />
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex xs12>
            <v-radio-group v-model="formData.refereed" row>
              <v-radio :label="$t('common.Refereed')" :value="true" :key="1" />
              <v-radio
                :label="$t('common.No') + ' ' + $t('common.Refereed')"
                :value="false"
                :key="2"
              />
            </v-radio-group>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex xs12>
            <v-radio-group v-model="formData.indexed" row>
              <v-radio :label="$t('common.Indexed')" :value="true" :key="1" />
              <v-radio
                :label="$t('common.No') + ' ' + $t('common.Indexed')"
                :value="false"
                :key="2"
              />
            </v-radio-group>
          </v-flex>
        </v-layout>
        <v-layout v-if="formData.type === 1 && this.formData.subType === 2">
          <v-flex xs12>
            <v-radio-group v-model="formData.scope" row>
              <v-radio
                v-for="presentationType in scopesPresentationType"
                :value="presentationType.value"
                :key="presentationType.value"
                :label="presentationType.text"
              />
            </v-radio-group>
          </v-flex>
        </v-layout>

        <v-text-field
          type="number"
          :rules="mandatoryRule"
          v-model="formData.impactFactor"
          :label="$t('common.ImpactFactor')"
          required
        />

        <v-layout>
          <v-flex xs3>
            <v-text-field
              :rules="mandatoryRule"
              v-model="formData.paperYear"
              :label="$t('common.Year')"
              type="number"
              class="mr-4"
              @keypress="isNumber($event)"
              required
            />
          </v-flex>
          <v-flex xs3>
            <v-text-field
              :rules="monthValidation"
              v-model="formData.month"
              :label="$t('common.Month')"
              type="number"
              class="mr-4"
              @keypress="isNumber($event)"
              required
            />
          </v-flex>
          <v-flex xs3>
            <v-text-field
              :rules="mandatoryRule"
              v-model="formData.paperPages"
              :label="$t('common.Pages')"
              type="text"
              class="mr-4"
              @keypress="isNumberOrHifen($event)"
              required
            />
          </v-flex>
          <v-flex xs3>
            <v-text-field
              :rules="mandatoryRule"
              v-model="formData.paperVolume"
              :label="$t('common.PaperVolume')"
              type="number"
              @keypress="isNumber($event)"
              required
            />
          </v-flex>
        </v-layout>
        <v-btn
          depressed
          color="primary"
          @click="e6 = hasJournal ? 4 : 3"
          :disabled="
            !formData.paperTitle ||
              !formData.refereed ||
              !formData.indexed ||
              !formData.impactFactor ||
              !formData.paperYear ||
              !formData.month ||
              !formData.paperPages ||
              !formData.paperVolume
          "
          >{{ $t('common.Continue') }}</v-btn
        >
        <v-btn flat @click="e6 = 2">{{ $t('common.Previous') }}</v-btn>
      </v-stepper-content>

      <v-stepper-step
        :complete="e6 > (hasJournal ? 4 : 3)"
        :step="hasJournal ? 4 : 3"
      >
        {{ $tc('common.Author', 2) }}
      </v-stepper-step>

      <v-stepper-content :step="hasJournal ? 4 : 3">
        <v-radio-group
          v-model="formData.autonomy"
          row
          @change="onAutonomyChanged"
        >
          <v-radio :label="$tc('common.Author')" :value="1" :key="1" />
          <v-radio :label="$t('common.CoAuthor')" :value="2" :key="2" />
        </v-radio-group>

        <v-text-field
          :disabled="formData.autonomy == 1"
          :rules="mandatoryRule"
          v-model="formData.firstAuthor"
          :label="$tc('common.Author')"
        />
        <v-text-field
          :disabled="formData.autonomy == 1"
          :rules="mandatoryRule"
          v-model="formData.firstAuthorId"
          :label="$tc('common.Author') + ' ' + $t('common.LicenseNumber')"
        />
        <v-text-field
          :disabled="formData.autonomy == 2"
          v-model="formData.secondAuthor"
          :label="$t('common.CoAuthor')"
        />
        <v-text-field
          :disabled="formData.autonomy == 2"
          v-model="formData.secondAuthorId"
          :label="$t('common.CoAuthor') + ' ' + $t('common.LicenseNumber')"
        />
        <div v-for="(author, index) in formData.authors" :key="index">
          <v-text-field
            v-model="author.authorName"
            :rules="mandatoryRule"
            :label="
              '' + (index + 3) + $t('common.th') + ' ' + $tc('common.Author')
            "
          />
          <v-text-field
            v-model="author.authorId"
            :rules="mandatoryRule"
            :label="
              '' +
                (index + 3) +
                $t('common.th') +
                ' ' +
                $tc('common.Author') +
                ' ' +
                $t('common.LicenseNumber')
            "
          />
        </div>

        <v-layout class="mb-2">
          <v-btn @click="formData.authors.push({})" small color="primary" dark>
            <v-icon>add</v-icon>
            {{ $t('scientificActivity.AddMoreAuthors') }}
          </v-btn>
        </v-layout>

        <v-btn
          depressed
          color="primary"
          @click="e6 = hasJournal ? 5 : 4"
          :disabled="!formData.title"
          >{{ $t('common.Continue') }}</v-btn
        >
        <v-btn flat @click="e6 = hasJournal ? 3 : 2">{{
          $t('common.Previous')
        }}</v-btn>
      </v-stepper-content>

      <v-stepper-step
        :complete="e6 > (hasJournal ? 5 : 4)"
        :step="hasJournal ? 5 : 4"
      >
        {{ $tc('scientificActivity.LinkNewCourse') }}
      </v-stepper-step>

      <v-stepper-content :step="hasJournal ? 5 : 4">
        <v-select
          v-if="!isLinking"
          :disabled="!canCreateCourse"
          item-text="title"
          item-value="id"
          v-model="formData.linkedCourseId"
          :items="courses"
          :label="$tc('common.Course', 1)"
        />

        <v-flex class="mb-3" xs6 v-if="canCreateCourse && !isLinking">
          <v-btn @click="courseDialog = true" small color="primary" dark>
            <v-icon>add</v-icon>
            {{ $t('scientificActivity.LinkNewCourse') }}
          </v-btn>
        </v-flex>

        <v-btn
          depressed
          color="primary"
          @click="e6 = hasJournal ? 6 : 5"
          :disabled="!formData.title"
        >
          {{ $t('common.Continue') }}
        </v-btn>
        <v-btn flat @click="e6 = hasJournal ? 4 : 3">{{
          $t('common.Previous')
        }}</v-btn>
      </v-stepper-content>

      <v-stepper-step
        :complete="e6 > (hasJournal ? 6 : 5)"
        :step="hasJournal ? 6 : 5"
      >
        {{ $tc('common.UploadFile') }}
      </v-stepper-step>

      <v-stepper-content :step="hasJournal ? 6 : 5">
        <file-upload
          :file-url-uploaded="formData.fileUrlAttached || ''"
          :file-name-uploaded="formData.fileNameAttached || ''"
          @fileRemoved="fileRemoved"
          @uploadComplete="fileAdded"
          :path-to-files="
            `${$store.getters.profile.id}/scientific-activities`
          "
        ></file-upload>

        <v-btn
          class="mt-4"
          :disabled="!valid"
          :loading="loading"
          color="success"
          @click="submit"
        >
          {{ $t('common.Submit') }}
        </v-btn>
        <v-btn flat @click="e6 = hasJournal ? 5 : 4">{{
          $t('common.Previous')
        }}</v-btn>
      </v-stepper-content>

      <v-layout row justify-end align-center class="mr-2">
        <v-btn flat @click="closePopUp">{{ $t('common.Cancel') }}</v-btn>
      </v-layout>
    </v-stepper>

    <v-dialog :persistent="true" v-model="courseDialog" max-width="600" lazy>
      <add-course-form
        :is-linking="true"
        :after-submit="afterCreateCourse"
        :form-data="newCourse"
        :close-me="() => (courseDialog = false)"
      />
    </v-dialog>
  </v-form>
</template>

<script>
import cms from '@/content'
import { mapGetters, mapActions } from 'vuex'
import Validations from '@/helpers/Validations'
import FileUpload from '@/components/files/FileUpload'

export default {
  name: 'AddEntryForm',
  components: {
    AddCourseForm: () => import('@/views/Course/AddCourseForm'),
    FileUpload
  },
  props: {
    afterSubmit: {
      required: false,
      type: Function
    },
    closeMe: {
      required: true,
      type: Function
    },
    isLinking: {
      type: Boolean,
      default: false
    },
    formData: {
      type: Object
    }
  },
  data() {
    return {
      e6: 0,
      courseDialog: false,
      loading: false,
      valid: false,
      datePicker: false,
      canCreateCourse: true,
      newCourse: {}
    }
  },
  computed: {
    ...mapGetters(['user', 'courses']),
    showDate() {
      return this.formData.type === 2 && !this.isLinking
    },
    hasJournal() {
      return (
        this.formData.type == 1 &&
        this.formData.subType &&
        this.formData.subType != 1
      )
    },
    mandatoryRule() {
      return [v => !!v || this.$t('common.RequiredField')]
    },
    monthValidation() {
      return [v => (1 <= v && v <= 12) || this.$t('common.MonthRule')]
    },
    types() {
      return cms.getScientificActivitiesTypes(this.$i18n.locale)
    },
    subTypesPublication() {
      return cms.getScientificActivitiesSubTypesPublication(this.$i18n.locale)
    },
    subTypesPresentation() {
      return cms.getScientificActivitiesSubTypesPresentation(this.$i18n.locale)
    },
    scopesPresentationType() {
      return cms.getScopesPresentationType(this.$i18n.locale)
    },
    typesOfPublication() {
      return cms.getTypesOfPublication(this.$i18n.locale)
    }
  },
  created() {
    this.onAutonomyChanged()
  },
  methods: {
    ...mapActions([
      'addScientificActivity',
      'updateScientificActivity',
      'showSuccessSnackbar',
      'getCourses'
    ]),
    isNumber(evt) {
      return Validations.isNumber(evt)
    },
    fileRemoved() {
      this.formData.fileUrlAttached = ''
      this.formData.fileNameAttached = ''
    },
    fileAdded(fileUrl, fileName) {
      this.formData.fileUrlAttached = fileUrl
      this.formData.fileNameAttached = fileName
    },
    isNumberOrHifen(evt) {
      return Validations.isNumberOrHifen(evt)
    },
    afterCreateCourse() {
      this.formData.linkedCourseId = this.courses[this.courses.length - 1].id
      this.canCreateCourse = false
    },
    onAutonomyChanged() {
      if (this.formData.autonomy === 1) {
        this.formData.firstAuthor = this.user.username
        this.formData.firstAuthorId = this.user.license
        this.formData.secondAuthor = ''
        this.formData.secondAuthorId = ''
      } else {
        this.formData.firstAuthor = ''
        this.formData.firstAuthorId = ''
        this.formData.secondAuthor = this.user.username
        this.formData.secondAuthorId = this.user.license
      }
    },
    closePopUp() {
      this.e6 = 1
      this.closeMe()
    },
    submit() {
      if (!this.$refs.form.validate()) {
        return
      }

      this.loading = true

      if (!this.formData.id) {
        this.formData.userId = this.$store.getters.profile.id
      }

      let action =
        this.formData && this.formData.id
          ? this.updateScientificActivity({
              id: this.formData.id,
              ...this.formData
            })
          : this.addScientificActivity(this.formData)

      action
        .then(() => {
          this.loading = false

          if (this.formData && this.formData.id) {
            this.showSuccessSnackbar('Scientific activity updated')
          } else {
            this.showSuccessSnackbar('Scientific activity created')
          }

          if (this.afterSubmit) {
            this.afterSubmit(this.formData)
          }

          this.$refs.form.reset()
          this.closeMe()
        })
        .catch(err => {
          this.loading = false
          this.$store.dispatch(
            'showErrorSnackbar',
            err.message || 'Something went wrong'
          )
        })
    }
  }
}
</script>

<style>
.theme--light.v-input--is-disabled input {
  color: black !important;
}
</style>
